module.exports = __webpack_public_path__ + "img/4.cc7ef871.png";